import { useCallback } from 'react';

import {
  useTrackAgentElicitationRequested,
  useTrackAgentElicitationResponded,
  type WorkspaceAgentGuidedFlowEntry,
} from '@air/analytics';

import { type GuidedVariantEditId } from '~/components/v2/components/workspace/workspace-agent-panel/constants/workspaceAgentGuidedVariantEdits';
import {
  buildWorkspaceAgentGuidedFlowElicitationRequestedParams,
  buildWorkspaceAgentGuidedFlowElicitationRespondedParams,
  toWorkspaceAgentGuidedVariantsAnalyticsEditId,
} from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentGuidedVariantAnalytics';

type UsePrivateWorkspaceAgentGuidedVariantFlowTrackingParams = {
  chatId: string | null;
};

type TrackGuidedVariantFlowOpenedParams = {
  entry: WorkspaceAgentGuidedFlowEntry;
};

export const usePrivateWorkspaceAgentGuidedVariantFlowTracking = ({
  chatId,
}: UsePrivateWorkspaceAgentGuidedVariantFlowTrackingParams) => {
  const { trackAgentElicitationRequested } = useTrackAgentElicitationRequested();
  const { trackAgentElicitationResponded } = useTrackAgentElicitationResponded();

  const trackGuidedVariantFlowOpened = useCallback(
    ({ entry }: TrackGuidedVariantFlowOpenedParams) => {
      trackAgentElicitationRequested(
        buildWorkspaceAgentGuidedFlowElicitationRequestedParams({
          chatId,
          entry,
        }),
      );
    },
    [chatId, trackAgentElicitationRequested],
  );

  const trackGuidedVariantFlowEditSelected = useCallback(
    (editId: GuidedVariantEditId) => {
      trackAgentElicitationResponded(
        buildWorkspaceAgentGuidedFlowElicitationRespondedParams({
          chatId,
          editId: toWorkspaceAgentGuidedVariantsAnalyticsEditId(editId),
        }),
      );
    },
    [chatId, trackAgentElicitationResponded],
  );

  return { trackGuidedVariantFlowEditSelected, trackGuidedVariantFlowOpened };
};
